import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useState } from 'react';
  const containerStyle = {
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "0px",
    width: "100%", 
    height: "200px", 
    overflow: "visible",
     minHeight: "200px",     
  height: "auto",          
  };

const EditorWithMentions = ({ value, onChange, suggestions }) => {
  const initialText = (value && value.trim() === '@') ? '' : value;

  const [editorState, setEditorState] = useState(
    initialText
      ? EditorState.createWithContent(ContentState.createFromText(initialText))
      : EditorState.createEmpty()
  );

  // const onEditorStateChange = (newState) => {
  //   setEditorState(newState);
  //   const html = draftToHtml(convertToRaw(newState.getCurrentContent()));
  //   onChange(html);
  // };
  const onEditorStateChange = (newState) => {
  setEditorState(newState);

  let html = draftToHtml(convertToRaw(newState.getCurrentContent()));

  // Replace the <a ...>@TAG</a> with <b>@TAG</b>
  html = html.replace(/<a [^>]*data-value="([^"]+)"[^>]*>@([^<]+)<\/a>/g, "<b>@$1</b>");

  onChange(html);
};


  return (
    <div style={containerStyle}>
      <Editor
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        mention={{
          separator: ' ',
          trigger: '@',
          suggestions: suggestions || [],
        }}
      />
    </div>
  );
};

export default EditorWithMentions;